import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ImmigrationWizardService } from '../services/immigration-wizard.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-review-analyze-petition-details',
  templateUrl: './review-analyze-petition-details.component.html',
  styleUrls: ['./review-analyze-petition-details.component.scss']
})
export class ReviewAnalyzePetitionDetailsComponent implements OnInit, OnDestroy {
  inputData: any;
  wizardInput: any;
  jobPositionTitle: any;
  isDataLoaded: boolean = false;
  observableSubscription$ = new Subject();
  isLinear = false;
  simplifyH1b: boolean  = true;
  stepId:number;
  // completed : boolean  = true;
  companyId;



  constructor(public immigrationWizardService: ImmigrationWizardService,private ngxService: NgxUiLoaderService) { }

  ngOnInit(): void {

    this.immigrationWizardService.getWizardTaskDetails$().subscribe((res: any) => {
      if(res){
        let stepData = res?.taskStepDetails.find(data => data.isBeneficiaryAction==0 && data.stepName == "Review Petition");
        this.inputData = {
          "superTaskId": res.superTaskId,
          "subTaskId": res.id,
          "caseType": res.subTaskTypeCode,
          "caseId": res.petitionId, // 1519
          "petitionId": res.petitionId,
          "foreignCompanyId": null,
          "visatype": res.taskTypeDetails.visaType,
          "visaName": res.taskTypeDetails.visaName,
          "petitionType": res.taskTypeDetails.petitionType,
          "immSpecialistId": res.immSpecialistId,
          "attorneyId": res.attorneyId,
          "sponsorId": res.sponsorId,
          "familyId": res.familyId,
          "immigrationCategory": null,
          "immigrationCategoryName": null,
          "immigrationClassification": null,
          "immigrationClassificationName": null,
          "superTaskTypeCode": res.superTaskTypeCode,
          "getTaskType": res.taskTypeDetails.visaType,
          "jsonInput": null,
          "beneficiaryId": res.beneficiaryId,
          "relationshipCode": null,
          "taskTypeId": res.taskTypeId,
          "taskTypeSaveJsonId": null,
          // "stepId": 8524,
          "companyId": res.companyId,
          "petitionerId": res.taskStepDetails[0].petitionerId,
          "stepName": "Generate Letters",
          "layoutCode": "FILL_FORM",
          "taskId": res.taskStepDetails[0].taskId,
          "isCustomStep": false,
          "stepId": res.taskStepDetails?.find(x => x.stepName === 'Review Petition')?.id,
          
          // "isWizard": true,
          // "individualStepId": 6154,
          // "version": "wizard"
        }
        this.wizardInput = {
          title: 'Review & Analyze Petition Details',
          data: {
            taskId: res?.superTaskId,
            individual: res?.beneficiaryDetails?.firstName+" "+res?.beneficiaryDetails?.lastName,
            petitionType: res?.taskTypeDetails?.petitionType,
            status: res?.taskStatus?.name
          }
        } 
        this.isDataLoaded = true; 
        if(stepData?.stepStatusDetails?.stepStatusCode == "NEW" || stepData?.stepStatusDetails?.stepStatusCode == "INPROGRESS"){
          let stepDetailsData = {
            "benchMarkActionCode": "",
            "endDate": "",
            "isAttorneyNotify": 0,
            "isBeneficiaryNotify": 0,
            "isPetitionerNotify": 0,
            "receiptCategory": "",
            "receiptDate": "",
            "receiptNumber": "",
            "receiptType": "",
            "responseCode": null,
            "responseNote": "",
            "reviewCode": null,
            "reviewNote": null,
            "startDate": "",
            "statusCode": "INPROGRESS",
            "stepNote": "",
            "notesAvailable": false
          }
          this.onLoadStatus(stepDetailsData);
        }
      }
    });
  }

  onLoadStatus(stepDetailsData){
    this.immigrationWizardService.postH1BLottery(this.inputData.visatype, this.inputData.subTaskId, this.inputData.stepId, stepDetailsData).subscribe((response: any) => {
      if (response && response.status === 200) {
       // updating the step status
      }
    });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
}
